export const DeviceSettings_UPDATE_REQUEST = "DeviceSettings_UPDATE_REQUEST";
export const DeviceSettings_UPDATE_SUCCESS = "DeviceSettings_UPDATE_SUCCESS";
export const DeviceSettings_UPDATE_FAILURE = "DeviceSettings_UPDATE_FAILURE";

export const DeviceSettings_TYPE_REQUEST = "DeviceSettings_TYPE_REQUEST";
export const DeviceSettings_TYPE_SUCCESS = "DeviceSettings_TYPE_SUCCESS";
export const DeviceSettings_TYPE_FAILURE = "DeviceSettings_TYPE_FAILURE";

export const DEVICE_NETWORK_SETTINGS_UPDATE_REQUEST = "DEVICE_NETWORK_SETTINGS_UPDATE_REQUEST";
export const DEVICE_NETWORK_SETTINGS_UPDATE_SUCCESS = "DEVICE_NETWORK_SETTINGS_UPDATE_SUCCESS";
export const DEVICE_NETWORK_SETTINGS_UPDATE_FAILURE = "DEVICE_NETWORK_SETTINGS_UPDATE_FAILURE";

export const DEVICE_NETWORK_SETTINGS_GET_REQUEST = "DEVICE_NETWORK_SETTINGS_GET_REQUEST";
export const DEVICE_NETWORK_SETTINGS_GET_SUCCESS = "DEVICE_NETWORK_SETTINGS_GET_SUCCESS";
export const DEVICE_NETWORK_SETTINGS_GET_FAILURE = "DEVICE_NETWORK_SETTINGS_GET_FAILURE";

export const DEVICE_DISPLAY_SETTINGS_UPDATE_REQUEST = "DEVICE_DISPLAY_SETTINGS_UPDATE_REQUEST";
export const DEVICE_DISPLAY_SETTINGS_UPDATE_SUCCESS = "DEVICE_DISPLAY_SETTINGS_UPDATE_SUCCESS";
export const DEVICE_DISPLAY_SETTINGS_UPDATE_FAILURE = "DEVICE_DISPLAY_SETTINGS_UPDATE_FAILURE";

export const DEVICE_DISPLAY_CUSTOM_INTERFACE_UPDATE_REQUEST = "DEVICE_DISPLAY_CUSTOM_INTERFACE_UPDATE_REQUEST";
export const DEVICE_DISPLAY_CUSTOM_INTERFACE_UPDATE_SUCCESS = "DEVICE_DISPLAY_CUSTOM_INTERFACE_UPDATE_SUCCESS";
export const DEVICE_DISPLAY_CUSTOM_INTERFACE_UPDATE_FAILURE = "DEVICE_DISPLAY_CUSTOM_INTERFACE_UPDATE_FAILURE";

export const DEVICE_DISPLAY_RANDOM_KEYBOARD_UPDATE_REQUEST = "DEVICE_DISPLAY_RANDOM_KEYBOARD_UPDATE_REQUEST";
export const DEVICE_DISPLAY_RANDOM_KEYBOARD_UPDATE_SUCCESS = "DEVICE_DISPLAY_RANDOM_KEYBOARD_UPDATE_SUCCESS";
export const DEVICE_DISPLAY_RANDOM_KEYBOARD_UPDATE_FAILURE = "DEVICE_DISPLAY_RANDOM_KEYBOARD_UPDATE_FAILURE";

export const DEVICE_DISPLAY_SETTINGS_GET_REQUEST = "DEVICE_DISPLAY_SETTINGS_GET_REQUEST";
export const DEVICE_DISPLAY_SETTINGS_GET_SUCCESS = "DEVICE_DISPLAY_SETTINGS_GET_SUCCESS";
export const DEVICE_DISPLAY_SETTINGS_GET_FAILURE = "DEVICE_DISPLAY_SETTINGS_GET_FAILURE";

export const DEVICE_DOOR_CONTROL_SETTINGS_UPDATE_REQUEST = "DEVICE_DOOR_CONTROL_SETTINGS_UPDATE_REQUEST";
export const DEVICE_DOOR_CONTROL_SETTINGS_UPDATE_SUCCESS = "DEVICE_DOOR_CONTROL_SETTINGS_UPDATE_SUCCESS";
export const DEVICE_DOOR_CONTROL_SETTINGS_UPDATE_FAILURE = "DEVICE_DOOR_CONTROL_SETTINGS_UPDATE_FAILURE";

export const DEVICE_DOOR_CONTROL_SETTINGS_GET_REQUEST = "DEVICE_DOOR_CONTROL_SETTINGS_GET_REQUEST";
export const DEVICE_DOOR_CONTROL_SETTINGS_GET_SUCCESS = "DEVICE_DOOR_CONTROL_SETTINGS_GET_SUCCESS";
export const DEVICE_DOOR_CONTROL_SETTINGS_GET_FAILURE = "DEVICE_DOOR_CONTROL_SETTINGS_GET_FAILURE";


export const DEVICE_QR_NFC_SETTINGS_UPDATE_REQUEST = "DEVICE_QR_NFC_SETTINGS_UPDATE_REQUEST";
export const DEVICE_QR_NFC_SETTINGS_UPDATE_SUCCESS = "DEVICE_QR_NFC_SETTINGS_UPDATE_SUCCESS";
export const DEVICE_QR_NFC_SETTINGS_UPDATE_FAILURE = "DEVICE_QR_NFC_SETTINGS_UPDATE_FAILURE";

export const DEVICE_QR_NFC_SETTINGS_GET_REQUEST = "DEVICE_QR_NFC_SETTINGS_GET_REQUEST";
export const DEVICE_QR_NFC_SETTINGS_GET_SUCCESS = "DEVICE_QR_NFC_SETTINGS_GET_SUCCESS";
export const DEVICE_QR_NFC_SETTINGS_GET_FAILURE = "DEVICE_QR_NFC_SETTINGS_GET_FAILURE";

export const DEVICE_AUDIO_ALARM_SETTINGS_UPDATE_REQUEST = "DEVICE_AUDIO_ALARM_SETTINGS_UPDATE_REQUEST";
export const DEVICE_AUDIO_ALARM_SETTINGS_UPDATE_SUCCESS = "DEVICE_AUDIO_ALARM_SETTINGS_UPDATE_SUCCESS";
export const DEVICE_AUDIO_ALARM_SETTINGS_UPDATE_FAILURE = "DEVICE_AUDIO_ALARM_SETTINGS_UPDATE_FAILURE";

export const DEVICE_AUDIO_ALARM_SETTINGS_GET_REQUEST = "DEVICE_AUDIO_ALARM_SETTINGS_GET_REQUEST";
export const DEVICE_AUDIO_ALARM_SETTINGS_GET_SUCCESS = "DEVICE_AUDIO_ALARM_SETTINGS_GET_SUCCESS";
export const DEVICE_AUDIO_ALARM_SETTINGS_GET_FAILURE = "DEVICE_AUDIO_ALARM_SETTINGS_GET_FAILURE";


export const DEVICE_PERIPHERAL_SETTINGS_UPDATE_REQUEST = "DEVICE_PERIPHERAL_SETTINGS_UPDATE_REQUEST";
export const DEVICE_PERIPHERAL_SETTINGS_UPDATE_SUCCESS = "DEVICE_PERIPHERAL_SETTINGS_UPDATE_SUCCESS";
export const DEVICE_PERIPHERAL_SETTINGS_UPDATE_FAILURE = "DEVICE_PERIPHERAL_SETTINGS_UPDATE_FAILURE";

export const DEVICE_PERIPHERAL_REMOTE_UPGRADE_SETTINGS_UPDATE_REQUEST = "DEVICE_PERIPHERAL_REMOTE_UPGRADE_SETTINGS_UPDATE_REQUEST";
export const DEVICE_PERIPHERAL_REMOTE_UPGRADE_SETTINGS_UPDATE_SUCCESS = "DEVICE_PERIPHERAL_REMOTE_UPGRADE_SETTINGS_UPDATE_SUCCESS";
export const DEVICE_PERIPHERAL_REMOTE_UPGRADE_SETTINGS_UPDATE_FAILURE = "DEVICE_PERIPHERAL_REMOTE_UPGRADE_SETTINGS_UPDATE_FAILURE";

export const DEVICE_PERIPHERAL_REMOTE_UPGRADE_FIRMWARE_SETTINGS_UPDATE_REQUEST = "DEVICE_PERIPHERAL_REMOTE_UPGRADE_FIRMWARE_SETTINGS_UPDATE_REQUEST";
export const DEVICE_PERIPHERAL_REMOTE_UPGRADE_FIRMWARE_SETTINGS_UPDATE_SUCCESS = "DEVICE_PERIPHERAL_REMOTE_UPGRADE_FIRMWARE_SETTINGS_UPDATE_SUCCESS";
export const DEVICE_PERIPHERAL_REMOTE_UPGRADE_FIRMWARE_SETTINGS_UPDATE_FAILURE = "DEVICE_PERIPHERAL_REMOTE_UPGRADE_FIRMWARE_SETTINGS_UPDATE_FAILURE";

export const DEVICE_PERIPHERAL_RELAY_CUSTOM_UPDATE_REQUEST = "DEVICE_PERIPHERAL_RELAY_CUSTOM_UPDATE_REQUEST";
export const DEVICE_PERIPHERAL_RELAY_CUSTOM_UPDATE_SUCCESS = "DEVICE_PERIPHERAL_RELAY_CUSTOM_UPDATE_SUCCESS";
export const DEVICE_PERIPHERAL_RELAY_CUSTOM_UPDATE_FAILURE = "DEVICE_PERIPHERAL_RELAY_CUSTOM_UPDATE_FAILURE";


export const DEVICE_PERIPHERAL_EVENT_REPORT_UPDATE_REQUEST = "DEVICE_PERIPHERAL_EVENT_REPORT_UPDATE_REQUEST";
export const DEVICE_PERIPHERAL_EVENT_REPORT_UPDATE_SUCCESS = "DEVICE_PERIPHERAL_EVENT_REPORT_UPDATE_SUCCESS";
export const DEVICE_PERIPHERAL_EVENT_REPORT_UPDATE_FAILURE = "DEVICE_PERIPHERAL_EVENT_REPORT_UPDATE_FAILURE";

export const DEVICE_PERIPHERAL_SETTINGS_GET_REQUEST = "DEVICE_PERIPHERAL_SETTINGS_GET_REQUEST";
export const DEVICE_PERIPHERAL_SETTINGS_GET_SUCCESS = "DEVICE_PERIPHERAL_SETTINGS_GET_SUCCESS";
export const DEVICE_PERIPHERAL_SETTINGS_GET_FAILURE = "DEVICE_PERIPHERAL_SETTINGS_GET_FAILURE";
